import PythonFlaskExceptionAutocapture from "../../../../contents/docs/libraries/python/_snippets/python-flask-exception-autocapture.mdx";
import * as React from 'react';
export default {
  PythonFlaskExceptionAutocapture,
  React
};